module.exports = __webpack_public_path__ + "img/12.3bea7d6c.png";